export const PromoCodeType = {
    DISCOUNT_ABSOLUTE   : 1,
    DISCOUNT_PERCENT    : 2,
    DELIVERY_DISCOUNT   : 3,
    FREE_ITEM           : 4,
}

export const promoCodeTypesMap = {
    [PromoCodeType.DISCOUNT_ABSOLUTE]: {
        key: PromoCodeType.DISCOUNT_ABSOLUTE,
        value: PromoCodeType.DISCOUNT_ABSOLUTE,
        label: "Discount Value",
    },
    [PromoCodeType.DISCOUNT_PERCENT]: {
        key: PromoCodeType.DISCOUNT_PERCENT,
        value: PromoCodeType.DISCOUNT_PERCENT,
        label: "Discount Percent",
    },
    [PromoCodeType.DELIVERY_DISCOUNT]: {
        key: PromoCodeType.DELIVERY_DISCOUNT,
        value: PromoCodeType.DELIVERY_DISCOUNT,
        label: "Delivery Discount",
    },
    [PromoCodeType.FREE_ITEM]: {
        key: PromoCodeType.FREE_ITEM,
        value: PromoCodeType.FREE_ITEM,
        label: "Free Item",
        hint: "Discount up to X price will be given when user purchase any item from the selected category. If multiple item choosen, only ONE with highest price will be selected and given discount"
    },
}

export const promoCodeTypes = [
    promoCodeTypesMap[PromoCodeType.DISCOUNT_ABSOLUTE],
    promoCodeTypesMap[PromoCodeType.DISCOUNT_PERCENT],
    promoCodeTypesMap[PromoCodeType.DELIVERY_DISCOUNT],
    promoCodeTypesMap[PromoCodeType.FREE_ITEM],
];